import { IComment } from '@/shared/IComment'
import React from 'react'
import { Comment } from './Comment';
import { HStack, IconButton, VStack } from '@chakra-ui/react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { CommentsService } from '@/app/services/CommentsService';
import { COMMENT_STATUS } from '@/shared/constants';
import { Model } from 'survey-core'

export const CommentTread = (props: {
  comment: IComment,
  allComments: IComment[],
  survey: Model,
  onSend: (comment: IComment) => Promise<any>,
  onDelete: (comment: IComment) => Promise<any>,
  onEdit: (comment: IComment) => Promise<any>,
  onCancel: () => void,
  onNavigate: (comment: IComment) => void,
  onReply: (comment: IComment) => void,
  editCommentId: string | undefined,
}) => {

  const [comment, setComment] = React.useState(props.comment);

  React.useEffect(() => {
    setComment(props.comment);
  }, [props.comment, props.editCommentId]);

  const childComments = props.allComments
    .filter(c => c.threadId === comment.id)
    .sort(CommentsService.compareTimestamp);

  const [isExpanded, setIsExpanded] = React.useState(comment.status !== COMMENT_STATUS.RESOLVED);

  const onReply = (comment: IComment) => {
    props.onReply(comment);
    setIsExpanded(true);
  }

  const isEdit = props.editCommentId === comment.id || childComments.some(c => c.id === props.editCommentId);

  const bg = comment.status === COMMENT_STATUS.RESOLVED ? '' : isEdit ? 'brand.50' : 'gray.50';

  return (
    <HStack w='full' align='start' gap='0' mt='4' border='1px solid' borderColor='gray' bg={bg} borderRadius='10'>
      <IconButton mt='2' mx='1'  size='xs' h='15' px='1' variant='ghost' icon={isExpanded ? <FiChevronDown /> : <FiChevronRight />} onClick={() => setIsExpanded(!isExpanded)} aria-label={''} />
      <VStack w='full' align='start' pr='4' spacing='0'>
        <Comment
          key={comment.id}
          comment={comment}
          survey={props.survey}
          status={comment.status}
          onSend={props.onSend}
          onDelete={props.onDelete}
          onEdit={props.onEdit}
          onCancel={props.onCancel}
          onNavigate={props.onNavigate}
          onReply={onReply}
          editCommentId={props.editCommentId}
          showReply={childComments.length === 0 || !isExpanded}
        />
        {isExpanded && childComments.map((childComment, i) => (
          <Comment
            key={childComment.id}
            comment={childComment}
            survey={props.survey}
            status={comment.status}
            onSend={props.onSend}
            onDelete={props.onDelete}
            onEdit={props.onEdit}
            onCancel={props.onCancel}
            onNavigate={props.onNavigate}
            onReply={props.onReply}
            editCommentId={props.editCommentId}
            showReply={i == childComments.length - 1}
          />
        ))}
      </VStack>
    </HStack>
  )
}